import { render, staticRenderFns } from "./PickItemArea.vue?vue&type=template&id=3ea736e8&"
import script from "./PickItemArea.vue?vue&type=script&lang=js&"
export * from "./PickItemArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports